import React from 'react';
import { Navbar } from '../components/Navbar';
import { ClompApi } from '../api/ClompApi';

const api = new ClompApi();

export class ProfilePage extends React.Component {

    constructor(props) {
        super(props);

        let id = this.props.match.params.id;
        if (id === undefined) {
            id = -1;
        }
        this.state = {
            loading: true,
            id: id,
            bio: 'No bio set',
            isMine: false
        }

    }

    componentDidMount() {
        if (this.state.id === -1 && localStorage.getItem('token') !== null) {
            api.auth.getUserByToken(localStorage.getItem('token')).then(response => {
                this.setState({
                    id: response
                });
            });
        }
    }

    render() {

        return (
            <>
                <Navbar history={this.props.history}></Navbar>
                {this.state.id !== -1 ? 
                <div>
                    <div className="profile-page">
                        <div className="profile-page-header">
                            <h1>Profile</h1>
                            <div className="profile-page-header-avatar">
                                <img src="https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50?s=200" alt="avatar" />
                            </div>
                            <div className="profile-page-header-bio">
                                <h1>{this.state.id}</h1>
                                <h3>Bio</h3>
                                <p>"{this.state.bio}"</p>
                                {this.state.isMine ? <div>
                                    <button>Edit</button>
                                </div> : null}
                            </div>
                            {this.state.isMine ? <div>
                               <button>Edit Profile</button>
                            </div> : null}
                        </div>
                        <div className="profile-page-achievements">
                            <h3>Achievements</h3>
                            <div className="profile-page-achievements-list">

                            </div>
                        </div>
                        {this.state.isMine ? null : <div className="profile-page-add-friend">
                            <button>Add friend</button>
                        </div>}  
                    </div>
                </div>
                : null}
            </>
        );
        
    }

}